<template>
  <div class="to-do-card">
    <LvTooltipButton
      v-if="$_isDisplay('checkIcon')"
      ref="LvTooltipButton"
      gray
      icon="icon-check-circle-outline"
      activeIcon="icon-check-circle-filled"
      :active="complete"
      :longWidth="!priority"
      :tooltipText="_tooltipText"
      :notAllow="!priority || !updatable || !reply"
      :activeTooltipText="_activeTooltipText"
      @click="$_checkComplete()"
    />
    <div class="card-container">
      <div class="card-item">
        <p class="card-item_text">
          {{ name }}
        </p>
      </div>
      <div v-if="multiSystemSubclasses && multiSystemSubclasses.length > 0" class="card-item item-content">
        <ContentChipsList :chips="multiSystemSubclasses" />
      </div>
      <div v-if="remark" class="card-item item-content">
        <p class="card-item_text">
          {{ remark }}
        </p>
      </div>
      <div v-if="$_isDisplay('taker') || $_isDisplay('date')" class="to-do-card__select-tool mt-16">
        <LlAvatar
          v-if="$_isDisplay('taker')"
          bold
          small
          :image="taker.avatar"
          :textLabel="taker.name"
          class="select"
        />
        <WsTextChip001
          v-if="$_isDisplay('date')"
          iconLg
          fontSizeSm
          leadingIcon="icon-duedate"
          :red="$_getDateExpired(expiredDate)"
          :textLabel="$_getDateTimeFormat(expiredDate, 'YYYY-MM-DD')"
          class="select"
        />
      </div>
      <div v-if="attaches.length > 0" class="file-tool" @click="$_fileToggle()">
        <WsTextButton001
          small
          primary
          noPadding
          leadingIcon="icon-attachment"
          :num="attaches.length"
        >
          {{ $t('附件') }}
        </WsTextButton001>
        <i v-if="fileShow" class="icon-arrow-drop-down icon blue" />
        <i v-else class="icon-arrow-drop-up icon blue" />
      </div>
      <slide-up-down v-if="attaches.length > 0" :active="fileShow" :duration="500">
        <div class="file-list">
          <LvDownloadFileBtn
            download
            v-for="(attach_e, attach_k) in attaches"
            :key="attach_k"
            :num="attach_k"
            :id="attach_e.id"
            :url="attach_e.url"
            :name="attach_e.name"
            :fileType="attach_e.fileType"
            :hasScope="attach_e.hasScope"
            :isSystem="attach_e.isSystem"
            :chipList="attach_e.chipList"
            :isLoading="attach_e.isLoading"
            :versionNumber="attach_e.versionNumber"
            :showDownloadBtn="attach_e.showDownloadBtn"
            :isClickable="attach_e.isClickable"
            :isImageViewable="_isImageViewable"
            class="file"
            @go-to="$_onGoToFile(attach_e.id)"
          />
        </div>
      </slide-up-down>
      <LvInfoTaskLinks v-if="links && links.length > 0" bgWhite :links="links" class="mt-16" />
      <div v-if="$_isDisplay('reply')" class="to-do-card_reply-wrap">
        <LvDivider marginBottom="8px" marginTop="8px" />
        <div class="to-do-card_reply-title">
          <p class="reply-title">
            {{ $t('執行結果') }}
          </p>
          <div v-if="replyUpdatedAt" class="title-content">
            <div class="title-item date">
              <i class="icon-time" />
              <p>{{ $t('編輯時間') }} {{ $_getDateTimeFormat(replyUpdatedAt) }}</p>
            </div>
            <div v-if="replyUpdateUser" class="title-item">
              <LlAvatar :text-label="replyUpdateUser.name" :image="replyUpdateUser.avatar" bold />
            </div>
          </div>
          <WsButton001
            v-if="updatable && (taker.id === _currentUser.id || taskTaker.id === _currentUser.id)"
            out-line
            medium-button
            flatButton
            class="edit-btn"
            @click="$_subTaskReplyOpen()"
          >
            {{ $t('編輯') }}
          </WsButton001>
        </div>
        <p class="to-do-card_reply-content">
          {{ reply ? reply : `（${$t('尚無回覆')}）` }}
        </p>
        <LvImgList
          v-if="replyImages.length > 0"
          :marginTop="15"
          :imageList="replyImages"
          @go-to="$_onGoToFile($event)"
        />
        <LvFileList
          v-if="replyAttaches.length > 0"
          twoItem
          nonBorderTop
          :value="replyAttaches"
          :marginTop="10"
          @go-to="$_onGoToFile($event)"
        />
      </div>
      <div v-if="$_isDisplay('review')" class="to-do-card_reply-wrap">
        <LvDivider marginBottom="8px" marginTop="8px" />
        <div class="to-do-card_reply-title">
          <p class="reply-title">
            {{ $t('審核結果') }}
          </p>
          <div v-if="reviewUpdatedAt" class="title-content">
            <div class="title-item date">
              <i class="icon-time" />
              <p>{{ $t('編輯時間') }} {{ $_getDateTimeFormat(reviewUpdatedAt) }}</p>
            </div>
            <div v-if="reviewUpdateUser" class="title-item">
              <LlAvatar :text-label="reviewUpdateUser.name" :image="reviewUpdateUser.avatar" bold />
            </div>
          </div>
          <WsButton001
            v-if="
              complete && reply && updatable && taskTaker.id === _currentUser.id && _scopeTaskCheck
            "
            out-line
            medium-button
            flatButton
            class="edit-btn"
            @click="$_subTaskReplyOpen()"
          >
            {{ $t('編輯') }}
          </WsButton001>
        </div>
        <p class="to-do-card_reply-content">
          {{ reviewRemark ? reviewRemark : `（${$t('尚無回覆')}）` }}
        </p>
        <LvImgList
          v-if="reviewImages.length > 0"
          :marginTop="15"
          :imageList="reviewImages"
          @go-to="$_onGoToFile($event)"
        />
        <LvFileList
          v-if="reviewAttaches.length > 0"
          twoItem
          nonBorderTop
          :value="reviewAttaches"
          :marginTop="10"
          @go-to="$_onGoToFile($event)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import S_scope from '@/service/api/v1/scope';
import H_time from '@/helpers/time';

export default {
  name: 'ToDoCard',
  props: {
    subTaskId: {
      type: [Number, String],
    },
    name: {
      type: String,
      default: '',
    },
    remark: {
      type: String,
      default: '',
    },
    expiredDate: {
      type: String,
      default: '',
    },
    taker: {
      //執行者
      type: Object,
      default() {
        return {};
      },
    },
    taskTaker: {
      //負責人
      type: Object,
      default() {
        return {};
      },
    },
    complete: {
      type: Boolean,
      default: false,
    },
    attaches: {
      type: Array,
      default() {
        return [];
      },
    },
    reply: {
      type: String,
      default: '',
    },
    replyUrl: {
      type: String,
      default: '',
    },
    replyImages: {
      type: Array,
      default() {
        return [];
      },
    },
    replyAttaches: {
      type: Array,
      default() {
        return [];
      },
    },
    priority: {
      type: Boolean,
      default: false,
    },
    reviewRemark: {
      type: String,
      default: '',
    },
    reviewImages: {
      type: Array,
      default() {
        return [];
      },
    },
    reviewAttaches: {
      type: Array,
      default() {
        return [];
      },
    },
    replyUpdateUser: {
      type: Object,
      default() {
        return {};
      },
    },
    reviewUpdateUser: {
      type: Object,
      default() {
        return {};
      },
    },
    replyUpdatedAt: {
      type: String,
      default: '',
    },
    reviewUpdatedAt: {
      type: String,
      default: '',
    },
    updatable: {
      type: Boolean,
      default: true,
    },
    links: {
      type: Array,
      default: () => [],
    },
    hideFields: {
      type: Array,
      default: () => [],
    },
    multiSystemSubclasses: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    fileShow: true,
    C_reply: '',
  }),
  computed: {
    _currentUser() {
      return this.$store.state.stone_auth.currentUser;
    },
    _scopeTaskCheck() {
      if (!this.taskTaker) return false;
      return S_scope.isScopeAndUserAvailable(['task-check-taker'], this.taskTaker.id);
    },
    _tooltipText() {
      if (!this.updatable) return '已完成覆核的待辦事項，不可以編輯';
      if (!this.priority) return '你無權限標記他人的待辦事項';
      return this.reply ? '標記為完成' : '尚未填寫執行結果';
    },
    _activeTooltipText() {
      if (!this.updatable) return '已完成覆核的待辦事項，不可以編輯';
      return this.priority ? '標記為未完成' : '你無權限標記他人的待辦事項';
    },
    _isImageViewable() {
      return this.$store.state.app.factory.isImageViewable;
    },
    _hideFieldsMap() {
      if (!Array.isArray(this.hideFields)) return null;
      return new Set(this.hideFields.filter(item => typeof item === 'string'));
    },
  },
  watch: {
    reply() {
      this.C_reply = this.reply;
    },
  },
  mounted() {
    this.C_reply = this.reply;
  },
  methods: {
    $_subTaskReplyOpen() {
      if (!this.priority) return;
      this.$emit('subtask-popup-open');
    },
    $_checkComplete() {
      if (!this.priority || !this.updatable || !this.reply) return;
      this.$emit('click');
    },
    $_fileToggle() {
      this.fileShow = !this.fileShow;
    },
    $_getDateTimeFormat(date, format = 'YYYY-MM-DD HH:mm:ss') {
      return H_time.getDateDashFormat(date, format);
    },
    $_getDateExpired(date) {
      return H_time.isExpired(date);
    },
    async $_replyClick() {
      let reply = this.C_reply;
      try {
        await this.$axios.patch(`${this.replyUrl}${this.subTaskId}`, {
          reply: reply,
        });
      } catch (err) {
        alert(this.$t('回覆發生錯誤'));
      }
    },
    $_onGoToFile($event) {
      this.$emit('go-to', $event);
    },
    $_isDisplay(field) {
      if (!this._hideFieldsMap) return true;
      const fieldValueExamList = {
        taker: () => this.taker?.name ?? false,
        date: () => this.expiredDate !== '' && this.expiredDate != null,
      };
      const hasValue = fieldValueExamList[field]?.() ?? true;
      return !this._hideFieldsMap.has(field) && hasValue;
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/component/to-do-card';
</style>
